import React, { useState } from "react";
import "./Weather.css";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");
  function convertToFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }
  function convertToCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  function fahrenheit() {
    return (props.celsius * 9) / 5 + 32;
  }

  if (unit === "celsius") {
    return (
      <div className="WeatherTemperature">
        {Math.round(props.celsius)}
        <span className="unit">
          °C |{" "}
          <a href="/" onClick={convertToFahrenheit} className="unitLink">
            °F
          </a>
        </span>
      </div>
    );
  } else {
    return (
      <div>
        {Math.round(fahrenheit())}
        <span className="unit">
          <a href="/" onClick={convertToCelsius} className="unitLink">
            {" "}
            °C{" "}
          </a>
          |°F
        </span>
      </div>
    );
  }
}
